//import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  props:{ 
    setSubscriptionDetails: {
      type: Function,
      required: true
    }
},
  components: {
    //Datepicker,
  },
  data: () => {
    return {
      detailsFlag: false,
      subscriptionPackages: [
        { name: "1 month", value: "1-m" },
        { name: "3 month", value: "3-m" },
        { name: "6 month", value: "6-m" },
        { name: "1 year", value: "12-m" },
      ],
      selectedPackage: "",
      currentPath: true,
      days: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
      ],
      selectedDay: null,
    };
  },
  created() {
    /* this.$router.history.listen((newLocation) => {
      this.currentPath =
        newLocation.name == "cart" || newLocation.name == "address";
    }); */
   
  },
  methods: {
    setDetailsFlag() {
      this.detailsFlag = !this.detailsFlag;
      if (!this.detailsFlag) {
        this.selectedPackage = "";
        this.selectedDay = null;
      }
    },
    setDetails() {
      // this.$emit("onDetailsSet", this.selectedPackage);
      this.setSubscriptionDetails({frequency: this.selectedPackage, day: this.selectedDay})
    },
    onDateChangeHandler() {
      console.log(this.selectedDay + moment().format("-MM-YYYY"));
      // this.$root.$emit("onSubscriptionDetailsSelect", {
      //   package: this.selectedPackage,
      //   date: this.selectedDay,
      // });

      this.setSubscriptionDetails({frequency: this.selectedPackage, day: this.selectedDay})
    },
  } /* 
  watch: {
    $route(to, from) {
      console.log("to", to);
    },
  }, */,
};
